export default {
	name: "Svenska",
	
	'global.itemCounts': `{total, plural,
		=0 {inget innehåll}
		other {}
	}{collections, plural,
		=0 {}
		one {en samling}
		other {{collections} samlingar}
	}{both, select,
		true {, }
		other {}
	}{stories, plural,
		=0 {}
		one {en berättelse}
		other {{stories} berättelser}
	}`,

	'cover.stories': `{itemCount, plural,
		one {berättelse}
		other {berättelser}
	}`,

	'searchbutton.placeholder': 'Sök...',

	'flow.empty': 'Det finns inget innehåll att visa.',

	'search.empty': 'Din sökning gav inga resultat.',

	'forms.submitted': 'Dina poster har skickats in framgångsrikt.',
	'forms.errored': 'Ett fel uppstod när du skickade in dina poster.',
	'forms.required': 'Det här inmatningsfältet krävs för att skicka formuläret.',
	'forms.close': 'Tack',

	'prevnext.prev': 'Föregående berättelse',
	'prevnext.next': 'Nästa berättelse',

	'navigation.back': 'tillbaka',
	
	'share.back': 'tillbaka',
	'share.embed': 'embed',
	'share.share': 'del',
	'share.cover': 'Cover',
	'share.custom': 'eget element',
	'share.inline': 'inbäddad direkt',
	'share.customhere': 'INSERT DIN EGNA PUNKT HÄR',
	'share.scriptonce': 'Ovanstående manus måste bara integreras en gång per sida',
	'share.FacebookLabel': 'Dela på Facebook',
	'share.TwitterLabel': 'tweet',
	'share.TwitterText': '{title}',
	'share.EmbedLabel': 'embed',

	'more.showCollection': 'Visa alla berättelser',
	'more.showMore': 'Visa äldre berättelser',
	'more.showMoreBack': '«',
	'more.showMoreSearch': 'Visa mer innehåll',
	'more.showMoreSearchBack': '«',

	'multislider.showAll': 'Visa alla berättelser',

	'passwordScreen.passwordPlaceholder': 'lösenord',
	'passwordScreen.usernamePlaceholder': 'användarnamn',
	'passwordScreen.subTitle': 'är en skyddad {type, select, story {berättelse} collection {samlingar}}',
	'passwordScreen.submit': 'logga in',
	'passwordScreen.error': 'Inloggning är inte möjlig!',

	'like.label': '{likeCount, number} Jag gillar det',
	'like.noLikeLabel': 'Jag gillar det',

};



// WEBPACK FOOTER //
// ./lib/locales/sv.js